Modal = require './modules/modal.coffee'

$ ->
	$topMenu = $ '.top-menu_ul'
	$subMenuA = $topMenu.find '.menu-item-has-children > a'
	$overlay = $ '#overlay'
	$rangeSliders = $ '.range-slider'
	$contactButtons = $ '.contactButton'
	$serviceContact = $ '.service-contact'

	for slider, i in $rangeSliders
		$slider = $rangeSliders.eq i

		$slider.ionRangeSlider
			hide_min_max: true
			grid: true
			onStart: =>
				setTimeout ->
					$slider.change()
				, 0

	$overlay.on 'click', (e) ->
		$target = $ e.target
		unless $target.closest('#modal').length
			$overlay.hide()

	$subMenuA.on 'click', (e) ->
		e.preventDefault()
		$this = $ this
		$item = $this.parent()
		$subMenu = $item.find '.sub-menu'
		isVisible = $subMenu.is ':visible'

		if isVisible
			$subMenu.hide()
		else
			$subMenu.show()

	$serviceContact.each ->
		$el = $ @
		$el.prev().addClass 'lower-indentation'

	$contactButtons.on 'click', (e) ->
		data =
			action: 'contactUs'

		modal = new Modal data
		modal.modal()


/** WEBPACK FOOTER **
 ** ./assets/coffee/main.coffee
 **/